import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import VisitorCounter from './VisitorCounter';
import CurseBless from './CurseBless';
import ProfilePic from '../images/Abel ProfilePic.jpg';
import Onlyfans from '../images/onlyfansimg.png';
import TikTokLogo from '../images/tiktokicon.png';
import WishList from '../images/Amazon-wishlist-icon-2.png';
import TwitterIcon from '../images/twitter.png';
import InstagramIcon from '../images/instagram.png';
import SoraIcon from '../images/chat-gpt.png';

const About = () => {
  return (
    <Wrapper>
      <AppTitle>Abeliciousness</AppTitle>
      <AppDescription>
        Welcome to Abeliciousness - A personal website showcasing my legendary.
        Come here to lurk, talk shit and roast me, gas me up, send me love, and
        post chisme with your stupid voices. Also post ass and titties. Sign in
        with Google to post comments, upload media, and interact with the
        community.
      </AppDescription>
      <Name>☠️Abel Mendoza☠️</Name>
      <Picture src={ProfilePic}></Picture>
      <Bio>Massive Legend</Bio>
      <OnlineStatus>
        <StatusDot></StatusDot>
        <StatusText>Online Now</StatusText>
      </OnlineStatus>
      <VisitorCounter />
      <CurseBless />
      <h1>Get to know Me</h1>
      <PrivacyLinkContainer>
        <PrivacyLink as={RouterLink} to="/privacy">Privacy Policy</PrivacyLink>
      </PrivacyLinkContainer>
      <Socials>
        <SocialLink
          href="https://twitter.com/A_BrownRecluse"
          target="_blank"
          rel="noopener noreferrer"
          title="Twitter"
          aria-label="Follow on Twitter"
        >
          <img alt="Twitter" src={TwitterIcon} width="50" height="50"></img>
          <Tooltip>Twitter</Tooltip>
        </SocialLink>
        <SocialLink
          href="https://www.instagram.com/abel_elreaper/"
          target="_blank"
          rel="noopener noreferrer"
          title="Instagram"
          aria-label="Follow on Instagram"
        >
          <img alt="Instagram" src={InstagramIcon} width="50" height="50"></img>
          <Tooltip>Instagram</Tooltip>
        </SocialLink>
        <SocialLink
          href="https://www.tiktok.com/@alereaperhomebrewing"
          target="_blank"
          rel="noopener noreferrer"
          title="TikTok"
          aria-label="Follow on TikTok"
        >
          <i className="fab fa-tiktok"></i>
          <Tooltip>TikTok</Tooltip>
        </SocialLink>
        <SocialLink
          href="https://onlyfans.com/neckromancer666"
          title="OnlyFans"
          aria-label="Visit OnlyFans"
        >
          <img alt="OF" src={Onlyfans} width="30" height="30"></img>
          <Tooltip>OnlyFans</Tooltip>
        </SocialLink>
        <SocialLink
          href="https://www.tiktok.com/@alereaperhomebrewing"
          target="_blank"
          rel="noopener noreferrer"
          title="TikTok"
          aria-label="Follow on TikTok (Homebrewing)"
        >
          <img alt="tiktok" src={TikTokLogo} width="50" height="50"></img>
          <Tooltip>TikTok</Tooltip>
        </SocialLink>
        <SocialLink
          href="https://www.amazon.com/hz/wishlist/ls/2J3EK9BGFIQL4?ref_=wl_share"
          target="_blank"
          rel="noopener noreferrer"
          title="Amazon Wishlist"
          aria-label="View Amazon Wishlist"
        >
          <img alt="wishlist" src={WishList} width="50" height="50"></img>
          <Tooltip>Amazon Wishlist</Tooltip>
        </SocialLink>
        <SocialLink
          href="https://sora.chatgpt.com/profile/abelxmendoza"
          target="_blank"
          rel="noreferrer"
          title="Sora"
        >
          <img alt="Sora" src={SoraIcon} width="50" height="50"></img>
          <Tooltip>Sora</Tooltip>
        </SocialLink>
      </Socials>
    </Wrapper>
  );
};

export default About;

const Wrapper = styled.div`
  color: white;
  font-weight: 1200px;
  max-width: 600px;
  margin: auto;
  margin-top: -5px;
  margin-bottom: 30px;
  line-height: 2.5em;
  padding-top: 20px;
  padding-bottom: 71px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-shadow: 2px 2px 8px #000000;

  /* Alienware Aurora 16X optimization (2560x1600) */
  @media (min-width: 2560px) {
    max-width: 900px;
    padding-top: 40px;
    padding-bottom: 100px;
    margin-bottom: 50px;
  }

  /* Large high-res displays */
  @media (min-width: 1920px) and (max-width: 2559px) {
    max-width: 750px;
    padding-top: 30px;
    padding-bottom: 80px;
  }

  /* iPhone 15+ and Samsung Galaxy optimization */
  @media (max-width: 430px) {
    max-width: 95%;
    padding-top: 15px;
    padding-bottom: 40px;
    margin-bottom: 20px;
  }

  @media (max-width: 390px) {
    max-width: 98%;
    padding-top: 10px;
    padding-bottom: 30px;
    margin-bottom: 15px;
  }

  @media (max-width: 360px) {
    max-width: 100%;
    padding-top: 8px;
    padding-bottom: 25px;
    margin-bottom: 10px;
  }
`;

const Name = styled.div`
  margin-top: 40px;
  font-size: 75px;
  font-weight: bold;
  margin-bottom: 15px;
  padding: 20px 40px;
  text-shadow: 2px 2px 8px #000000;
  cursor: pointer;
  letter-spacing: 3px;
  line-height: 1.4;
  width: auto;
  max-width: 100%;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  overflow: visible;

  /* Alienware Aurora 16X optimization */
  @media (min-width: 2560px) {
    font-size: 110px;
    margin-top: 50px;
    margin-bottom: 20px;
    padding: 30px 60px;
    letter-spacing: 5px;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    font-size: 90px;
    margin-top: 45px;
    margin-bottom: 18px;
    padding: 25px 50px;
    letter-spacing: 4px;
  }

  /* iPhone 15+ and Samsung Galaxy optimization */
  @media (max-width: 430px) {
    font-size: 45px;
    margin-top: 25px;
    margin-bottom: 12px;
    padding: 15px 25px;
    letter-spacing: 2px;
  }

  @media (max-width: 390px) {
    font-size: 40px;
    margin-top: 20px;
    margin-bottom: 10px;
    padding: 12px 20px;
    letter-spacing: 1.5px;
  }

  @media (max-width: 360px) {
    font-size: 36px;
    margin-top: 18px;
    margin-bottom: 8px;
    padding: 10px 18px;
    letter-spacing: 1px;
  }
`;

const Picture = styled.img`

  height: 700px;
  width: 600px;

  margin-top: 0px;
  cursor: pointer;
  border-radius: 9px 9px 9px 9px;
  -moz-border-radius: 9px 9px 9px 9px;
  -webkit-border-radius: 9px 9px 9px 9px;
  border: 0px solid #000000;
  -webkit-box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);
      -moz-box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);
      box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);
  &:hover {
        cursor: pointer;

      -webkit-box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);
      -moz-box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);
      box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);
    }
  
  /* Alienware Aurora 16X optimization (2560x1600) */
  @media (min-width: 2560px) {
    height: 1200px;
    width: 1000px;
    margin-top: 0px;
    -webkit-box-shadow: 15px 15px 50px 60px rgba(0,0,0,0.87);
    -moz-box-shadow: 15px 15px 50px 60px rgba(0,0,0,0.87);
    box-shadow: 15px 15px 50px 60px rgba(0,0,0,0.87);
  }
  
  /* Large high-res displays */
  @media (min-width: 1920px) and (max-width: 2559px) {
    height: 800px;
    width: 680px;
    margin-top: 25px;
    }
 
    @media (max-width: 1194px) {
      height: 600px;
      width: 500px; 
      -webkit-box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);
      -moz-box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);
      box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);


}

    @media (max-width: 1024px) {
      height: 500px;
      width: 400px; 
      -webkit-box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);
      -moz-box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);
      box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);


}

@media (max-width: 1024px) {
      height: 500px;
      width: 400px; 
      -webkit-box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);
      -moz-box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);
      box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);


}
 
    @media (max-width: 768px) {
    height: 400px;
  width: 300px; 
  -webkit-box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);
      -moz-box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);
      box-shadow: 10px 10px 39px 45px rgba(0,0,0,0.87);
  }
  
  /* iPhone 15+ and Samsung Galaxy optimization */
  @media (max-width: 430px) {
    height: 350px;
    width: 280px;
    margin-top: 15px;
  }
  
  @media (max-width: 390px) {
    height: 300px;
    width: 250px;
    margin-top: 10px;
  }
  
  @media (max-width: 360px) {
    height: 280px;
    width: 230px;
    margin-top: 10px;
  }
}





`;

const Bio = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
  font-size: 75px;
  font-weight: bold;
  padding: 20px 40px;
  text-shadow: 2px 2px 8px #000000;
  cursor: pointer;
  letter-spacing: 3px;
  line-height: 1.4;
  width: auto;
  max-width: 100%;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  overflow: visible;

  /* Alienware Aurora 16X optimization */
  @media (min-width: 2560px) {
    font-size: 110px;
    margin-top: 50px;
    margin-bottom: 40px;
    padding: 30px 60px;
    letter-spacing: 5px;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    font-size: 90px;
    margin-top: 45px;
    margin-bottom: 40px;
    padding: 25px 50px;
    letter-spacing: 4px;
  }

  /* iPhone 15+ and Samsung Galaxy optimization */
  @media (max-width: 430px) {
    font-size: 45px;
    margin-top: 30px;
    margin-bottom: 30px;
    padding: 15px 25px;
    letter-spacing: 2px;
  }

  @media (max-width: 390px) {
    font-size: 40px;
    margin-top: 25px;
    margin-bottom: 25px;
    padding: 12px 20px;
    letter-spacing: 1.5px;
  }

  @media (max-width: 360px) {
    font-size: 36px;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 10px 18px;
    letter-spacing: 1px;
  }
`;

const OnlineStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 40px;
  margin-top: 20px;
  font-family: 'Creepster', Arial, sans-serif;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 15px 30px;
  border-radius: 12px;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
  transform: translateZ(0);
  -webkit-transform: translateZ(0);

  /* Alienware Aurora 16X optimization */
  @media (min-width: 2560px) {
    gap: 18px;
    margin-bottom: 50px;
    margin-top: 30px;
    padding: 20px 40px;
    border-radius: 15px;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    gap: 15px;
    margin-bottom: 45px;
    margin-top: 25px;
    padding: 18px 35px;
    border-radius: 14px;
  }

  /* iPhone 15+ and Samsung Galaxy optimization */
  @media (max-width: 430px) {
    gap: 10px;
    margin-bottom: 25px;
    margin-top: 15px;
    padding: 12px 24px;
    border-radius: 10px;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
  }

  @media (max-width: 390px) {
    gap: 8px;
    margin-bottom: 20px;
    margin-top: 12px;
    padding: 10px 20px;
    border-radius: 8px;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
  }

  @media (max-width: 360px) {
    gap: 7px;
    margin-bottom: 15px;
    margin-top: 10px;
    padding: 8px 18px;
    border-radius: 8px;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
  }
`;

const StatusDot = styled.div`
  width: 16px;
  height: 16px;
  background-color: #00ff00;
  border-radius: 50%;
  box-shadow:
    0 0 10px #00ff00,
    0 0 15px #00ff00;
  animation: pulse 2s ease-in-out infinite;

  /* Alienware Aurora 16X optimization */
  @media (min-width: 2560px) {
    width: 24px;
    height: 24px;
    box-shadow:
      0 0 15px #00ff00,
      0 0 25px #00ff00;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    width: 20px;
    height: 20px;
    box-shadow:
      0 0 12px #00ff00,
      0 0 20px #00ff00;
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.7;
      transform: scale(1.1);
    }
  }
`;

const StatusText = styled.span`
  color: #00ff00;
  font-size: 28px;
  font-weight: bold;
  text-shadow:
    0 0 8px #00ff00,
    0 0 15px #00ff00,
    2px 2px 6px #000000;
  letter-spacing: 2px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  transform: translateZ(0);
  backface-visibility: hidden;

  /* Alienware Aurora 16X optimization */
  @media (min-width: 2560px) {
    font-size: 42px;
    text-shadow:
      0 0 12px #00ff00,
      0 0 20px #00ff00,
      2px 2px 8px #000000;
    letter-spacing: 3px;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    font-size: 36px;
    text-shadow:
      0 0 10px #00ff00,
      0 0 18px #00ff00,
      2px 2px 7px #000000;
    letter-spacing: 2.5px;
  }

  /* iPhone 15+ and Samsung Galaxy optimization */
  @media (max-width: 430px) {
    font-size: 22px;
    letter-spacing: 1.5px;
    text-shadow:
      1px 1px 0px #000000,
      0 0 4px #00ff00;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  @media (max-width: 390px) {
    font-size: 20px;
    letter-spacing: 1px;
    text-shadow:
      1px 1px 0px #000000,
      0 0 4px #00ff00;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  @media (max-width: 360px) {
    font-size: 18px;
    letter-spacing: 1px;
    text-shadow:
      1px 1px 0px #000000,
      0 0 4px #00ff00;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;

// Animated effects for Abeliciousness title
const glowPulse = keyframes`
  0%, 100% {
    text-shadow:
      2px 2px 0px #000000,
      -1px -1px 0px #000000,
      0 0 8px #9400d3,
      0 0 20px #7b00d4,
      0 0 35px #5a0099,
      0 0 50px #3d006b;
    transform: scale(1);
  }
  50% {
    text-shadow:
      2px 2px 0px #000000,
      -1px -1px 0px #000000,
      0 0 12px #b000ff,
      0 0 25px #9400d3,
      0 0 45px #7b00d4,
      0 0 65px #5a0099;
    transform: scale(1.02);
  }
`;

const creepyFloat = keyframes`
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  25% {
    transform: translateY(-3px) rotate(-0.5deg);
  }
  50% {
    transform: translateY(-5px) rotate(0deg);
  }
  75% {
    transform: translateY(-3px) rotate(0.5deg);
  }
`;

const AppTitle = styled.h1`
  font-size: 48px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  color: #9400d3;
  -webkit-text-stroke: 1px #000000;
  letter-spacing: 3px;
  animation:
    ${glowPulse} 3s ease-in-out infinite,
    ${creepyFloat} 4s ease-in-out infinite;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    animation:
      ${glowPulse} 1.5s ease-in-out infinite,
      ${creepyFloat} 2s ease-in-out infinite;
    transform: scale(1.05);
  }

  @media (min-width: 2560px) {
    font-size: 72px;
    margin-bottom: 30px;
    letter-spacing: 5px;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    font-size: 60px;
    margin-bottom: 25px;
    letter-spacing: 4px;
  }

  @media (max-width: 430px) {
    font-size: 32px;
    margin-bottom: 15px;
    letter-spacing: 2px;
  }

  @media (max-width: 390px) {
    font-size: 28px;
    margin-bottom: 12px;
    letter-spacing: 1.5px;
  }

  @media (max-width: 360px) {
    font-size: 24px;
    margin-bottom: 10px;
    letter-spacing: 1px;
  }
`;

const AppDescription = styled.p`
  font-size: 18px;
  text-align: center;
  margin-bottom: 30px;
  padding: 0 20px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  max-width: 800px;

  @media (min-width: 2560px) {
    font-size: 24px;
    margin-bottom: 40px;
    padding: 0 40px;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    font-size: 20px;
    margin-bottom: 35px;
    padding: 0 30px;
  }

  @media (max-width: 430px) {
    font-size: 16px;
    margin-bottom: 20px;
    padding: 0 15px;
  }

  @media (max-width: 390px) {
    font-size: 14px;
    margin-bottom: 18px;
    padding: 0 12px;
  }

  @media (max-width: 360px) {
    font-size: 13px;
    margin-bottom: 15px;
    padding: 0 10px;
  }
`;

const PrivacyLinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 20px;

  @media (max-width: 430px) {
    margin-top: 15px;
    gap: 8px;
  }
`;

const PrivacyLink = styled.a`
  display: inline-block;
  padding: 12px 24px;
  background-color: rgba(76, 0, 101, 0.6);
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-size: 18px;
  border: 2px solid rgba(76, 0, 101, 0.8);
  transition: all 0.3s ease;

  &:hover {
    background-color: rgba(76, 0, 101, 0.8);
    transform: scale(1.05);
    text-decoration: underline;
  }

  @media (max-width: 430px) {
    font-size: 16px;
    padding: 10px 20px;
  }

  @media (max-width: 390px) {
    font-size: 14px;
    padding: 8px 16px;
  }
`;

const Socials = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 15px;
`;

const SocialLink = styled.a`
  margin: 10px;
  font-size: 2rem;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: white;
  transition: all 0.3s ease;
  position: relative;

  /* Alienware Aurora 16X optimization (2560x1600) */
  @media (min-width: 2560px) {
    font-size: 3.5rem;
    margin: 15px;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    font-size: 3rem;
    margin: 12px;
  }

  &:hover {
    color: black;
    transform: scale(1.1);
  }

  /* iPhone 15+ and Samsung Galaxy optimization */
  @media (max-width: 430px) {
    margin: 5px;
    font-size: 1.5rem;
  }

  @media (max-width: 390px) {
    margin: 4px;
    font-size: 1.3rem;
  }

  @media (max-width: 360px) {
    margin: 3px;
    font-size: 1.2rem;
  }

  img {
    /* Alienware Aurora 16X optimization (2560x1600) */
    @media (min-width: 2560px) {
      width: 70px !important;
      height: 70px !important;
    }

    @media (min-width: 1920px) and (max-width: 2559px) {
      width: 60px !important;
      height: 60px !important;
    }

    @media (max-width: 768px) {
      width: 40px !important;
      height: 40px !important;
    }

    /* iPhone 15+ and Samsung Galaxy optimization */
    @media (max-width: 430px) {
      width: 35px !important;
      height: 35px !important;
    }

    @media (max-width: 390px) {
      width: 30px !important;
      height: 30px !important;
    }

    @media (max-width: 360px) {
      width: 28px !important;
      height: 28px !important;
    }
  }
`;

const Tooltip = styled.span`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
  padding: 6px 12px;
  background-color: rgba(0, 0, 0, 0.9);
  color: white;
  font-family: 'Creepster', Arial, sans-serif;
  font-size: 0.9rem;
  white-space: nowrap;
  border-radius: 6px;
  opacity: 0;
  pointer-events: none;
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
  z-index: 1000;
  border: 1px solid rgba(76, 0, 101, 0.5);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);

  /* Arrow */
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: rgba(0, 0, 0, 0.9);
  }

  ${SocialLink}:hover & {
    opacity: 1;
    transform: translateX(-50%) translateY(-5px);
  }

  /* Alienware Aurora 16X optimization */
  @media (min-width: 2560px) {
    font-size: 1.1rem;
    padding: 8px 16px;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    font-size: 1rem;
    padding: 7px 14px;
  }

  /* iPhone 15+ and Samsung Galaxy optimization */
  @media (max-width: 430px) {
    font-size: 0.8rem;
    padding: 5px 10px;
  }

  @media (max-width: 390px) {
    font-size: 0.75rem;
    padding: 4px 8px;
  }

  @media (max-width: 360px) {
    font-size: 0.7rem;
    padding: 4px 8px;
  }
`;
